export var IdGameTrackingShopState;
(function (IdGameTrackingShopState) {
    IdGameTrackingShopState["BACK_TO_OFFERS"] = "back_to_offers";
    IdGameTrackingShopState["CHECKOUT"] = "checkout";
    IdGameTrackingShopState["INSPECTED_GAME_PACKAGE"] = "inspected_game_package";
    IdGameTrackingShopState["LOADED_GAME_PACKAGE"] = "loaded_game_package";
    IdGameTrackingShopState["PAYMENT_FAILURE"] = "payment_failure";
    IdGameTrackingShopState["PAYMENT_SUCCESSFUL"] = "payment_successful";
    IdGameTrackingShopState["PROVIDER_SELECT"] = "selected_provider";
    IdGameTrackingShopState["PROVIDER_NAVIGATE"] = "navigation_click_provider";
    IdGameTrackingShopState["SELECTED_GAME_PACKAGE"] = "selected_game_package";
    IdGameTrackingShopState["SHOP_CLICK"] = "shop_click";
    IdGameTrackingShopState["SHOP_PACKAGE_LOADING_END"] = "shop_package_loading_end";
    IdGameTrackingShopState["SHOP_PACKAGE_LOADING_START"] = "shop_package_loading_start";
    IdGameTrackingShopState["SHOP_QUIT"] = "shop_quit";
    IdGameTrackingShopState["STORE_PAYMENT_FAILURE"] = "store_payment_failure";
    IdGameTrackingShopState["STORE_PAYMENT_SUCCESSFUL"] = "store_payment_successful";
    IdGameTrackingShopState["VIEW_LOADED"] = "view_loaded";
})(IdGameTrackingShopState || (IdGameTrackingShopState = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/IdGameTrackingShopState.ts
// module id = 218
// module chunks = 3